module.exports = __webpack_public_path__ + "img/2.96c55314.png";